export const parseJSONifiedStringOrGetRaw = (str: string) => {
  return str.match(/^".+"$/) ? JSON.parse(str) : str;
};
